import { ObligationRulesCategory } from '@commenda/prisma';
import { TaxClassificationEntityTypeEnum } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function generateComplianceCalendar({
  corporation,
  token,
}: {
  corporation: {
    firstFiscalYear: number;
    lastFiscalYear: number;
    corporationId: number;
    assignedCAFirmId?: string;
    assignCompliancesOnlyForEffectiveDate?: boolean;
    complianceCategories?: ObligationRulesCategory[];
    taxElection?: TaxClassificationEntityTypeEnum | null;
    commendaManagedFiscalYear?: number;
  };
  token?: string;
}): Promise<Response> {
  const res = await fetcher(
    'compliance/calendar',
    {
      method: 'POST',
      body: corporation,
    },
    token
  );

  return res;
}
